import { render, staticRenderFns } from "./DVideoSecure.vue?vue&type=template&id=38623a9f&scoped=true&"
import script from "./DVideoSecure.vue?vue&type=script&lang=js&"
export * from "./DVideoSecure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38623a9f",
  null
  
)

export default component.exports